import useActionsOfferAdvancedForm from './useActionsOfferAdvancedForm'

export default useActionsOfferAdvancedForm
